import {
	CANCEL_SEARCH,
	LOAD_FOLDERS,
	LOAD_FOLDERS_SUCCESS,
	LOAD_ITEMS,
	LOAD_ITEMS_SUCCESS,
	ORDER_BY,
	FILTER_BY,
	SEARCH,
	SEARCH_SUCCESS,
	UPDATE_ITEMS
} from './actions';

export default function chooseReducerToRunAction(actionType) {
	switch (actionType) {

	case SEARCH:
	case LOAD_FOLDERS:
	case LOAD_ITEMS:
	case LOAD_FOLDERS_SUCCESS:
	case LOAD_ITEMS_SUCCESS:
	case SEARCH_SUCCESS:
	case CANCEL_SEARCH:
	case ORDER_BY:
	case FILTER_BY:
		return { runOnCurrent: true };
	case UPDATE_ITEMS:
		return { runOnCurrent: true, runOnPrimary: true }; 
	default:
		return { runOnPrimary: true };
	}
}
